// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2xw1Y","modalFooterButton":"ModalNotes_modalFooterButton___lIPl"};